import { NavConfig } from 'src/models/configs/navConfig';

const initData: NavConfig[] = [];

import { useState } from 'react';
import { HttpResult } from '../../models/API';
import { jsonGet } from '../../utils/http';
import { useEffectAsync } from '../useEffectAsync';

/**
 * @param  {string} url - TODO: add url validator
 * @param  {any[]} inputs - an array of affective variables.
 */
export const useNavConfig = (inputs: any[] = []): [NavConfig[], boolean, boolean] => {
    interface NavConfigHttpResult extends HttpResult {
        body: {
            data: NavConfig[],
        }
    }
    const [data, setData] = useState(initData);
    const [loading, setLoading]: [boolean, any] = useState(true);
    const [error, setError]: [boolean, any] = useState(false);
    useEffectAsync(async () => {
        const res = await jsonGet('//v3.sohu.com/navs/config') as NavConfigHttpResult;
        if (res.status === 200 && res.body && Array.isArray(res.body.data)) {
            setLoading(false);
            setData(res.body.data);
        } else {
            setError(true);
            setLoading(false);
        }
    }, [...inputs]);
    return [data, loading, error];
};



// WEBPACK FOOTER //
// ./src/hooks/APIs/useNavConfig.ts